// extracted by mini-css-extract-plugin
export default {"hearingsNotesTitle":"Hearings_hearingsNotesTitle__xh6ni","notes":"Hearings_notes__bGAbI"};